import React from "react";
import styles from "./style.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { installmentsAlertStateEnum } from "@src/components/Tabs/Overview/store/constants.js";

import { showApplyCouponBottomSheetAction } from "@src/components/BottomSheets/store/actions";
import { openInstallmentUtil } from "../OverviewContent/utility";
import { useTranslation } from "react-i18next";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import MultipleValidity from "../MultipleValidity";
import DownloadBundleReceipt from "./PricingAccordion/DownloadBundleReceipt";
import MultipleValidityCardListing from "../MultipleValidity/MultipleValidityCardListing";
import { getGraphCoursePriceDetailsAction, setValidity } from "../../store/actions";
import { useRouter } from "@src/lib/router";

import RightArrowIcon from "@src/components/AccentIcons/RightArrowIcon";
import Coupons from "@src/components/Tabs/Overview/components/Coupons/index";
import PricingAccordion from "./PricingAccordion";
import PayInstallments from "./PayInstallments";
import StateSelection from "./StateSelection";
import DownloadReceipt from "./PricingAccordion/DownloadReceipt";
import PaidSummary from "./PaidSummary";

const PricingSection = ({
  overviewServerData,
  getCourseCouponListStudentDataServer,
  openModal,
  multipleValidityData,
  isStandAlone = false
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const state = useSelector((state) => {
    if (state?.overviewReducer?.overViewDetails?.course?.details?.name) {
      return state?.overviewReducer?.overViewDetails?.course;
    } else return overviewServerData?.course;
  });
  const bundledReceipt = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundledReceipt
  );

  const overviewReducerData = useSelector((state) => state?.overviewReducer);

  const showCouponsEverywhere = useSelector(
    (state) => state?.overviewReducer?.showCouponsEverywhere
  );

  const multipleCouponsConditions = useSelector(
    (state) => state?.overviewReducer?.multipleCouponsConditions
  );

  const pricingDetails = useSelector(
    (state) => state?.overviewReducer?.graphCourseData?.coupons?.[0]
  );

  const isInternational = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.orgDetails
        ?.isInternational
  );
  const autopayConfigId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.autopayConfig?.id || null
  );

  const onClickHandler = (selectedValidity) => {
    localStorage.setItem(
      "selectedValidity",
      JSON.stringify({ courseId: router?.query?.courseId, ...selectedValidity })
    );
    dispatch(setValidity(selectedValidity));
    dispatch(
      getGraphCoursePriceDetailsAction({
        courseIds: [`${router.query.courseId}`],
        isBundlingCourse: false,
        avoidCouponsList: true,
        ocvmId: selectedValidity?.id || null,
        autopayConfigId: autopayConfigId || null
      })
    );
  };

  // console.log(state, "state----");

  const handleTC = () => {
    // alert(state?.details?.tncUrl);
    hitDeeplinkExecutedV2(
      JSON.stringify({
        screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
        paramOne: state?.details?.tncUrl,
      }),
      JSON.stringify({
        screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
        paramOne: state?.details?.tncUrl,
      })
    );
  };

  const graphCouponLists = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListData?.coupons
  );

  const multipleValiditySelected = useSelector(
    (state) => state.overviewReducer.multipleValiditySelected
  );

  const isPurchased = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased
  );

  const dispatch = useDispatch();

  return (
    <div className={styles.PricingSection}>
      {multipleValiditySelected && isPurchased === 0 && (
        <>
          {isStandAlone ? (
          <div>
            <p className={styles.standAloneMultipleValidity}>Choose validity</p>
             <MultipleValidityCardListing data={multipleValidityData} handleSelectedData={onClickHandler}/>
          </div>) : (<MultipleValidity
            openModal={openModal}
            additionalClasses={styles.multipleValidity}
          />)}
          <hr className={styles.horizontalLine} />
        </>
      )}
      <div className={styles.PricingSection__Heading}>
        <span>
          {t(
            "components.tabs.overview.components.PricingDetails.heading",
            "Pricing Details"
          )}
        </span>
        {/* Normal Course Invoice */}
        {state?.metaData?.isPurchased &&
        state?.paymentSummary?.receiptUrl &&
        !bundledReceipt &&
        (!state?.paymentSummary?.platformReceipt && !state?.paymentSummary?.moneyBackReceipt && !state?.paymentSummary?.guaranteedSelectionProgramFeeReceipt) ? (
          <span>
            <DownloadReceipt data={state?.paymentSummary} />
          </span>
      ) : null}
      {state?.metaData?.isPurchased &&
        state?.paymentSummary?.receiptUrl &&
        bundledReceipt &&
        (state?.paymentSummary?.platformReceipt || state?.paymentSummary?.moneyBackReceipt || state?.paymentSummary?.guaranteedSelectionProgramFeeReceipt || bundledReceipt) ? (
          <span>
            <DownloadBundleReceipt data={state?.paymentSummary} />
          </span>
      ) : null}

      {/* Normal Course Invoice + money back or platform fee (any combination) */}
      {state?.metaData?.isPurchased &&
        state?.paymentSummary?.receiptUrl &&
        !bundledReceipt &&
        (state?.paymentSummary?.platformReceipt || state?.paymentSummary?.moneyBackReceipt || state?.paymentSummary?.guaranteedSelectionProgramFeeReceipt) ? (
          <span>
            <DownloadBundleReceipt data={state?.paymentSummary} />
          </span>
      ) : null}
      </div>
      {state?.paymentSummary ||
      state?.installments?.paidInstallmentSummary?.isPaymentComplete ==
        0 ? null : pricingDetails?.priceDetailNew?.label ? (
        <PricingAccordion />
      ) : null}
      {overviewReducerData?.overViewDetails?.course?.metaData?.isPurchased ||
      overviewReducerData?.overViewDetails?.course?.installments
        ?.purchasedViaInstallment === 1 ? null : showCouponsEverywhere && !isStandAlone &&
        multipleCouponsConditions < 3 ? (
        <Coupons
          overviewServerData={overviewServerData}
          getCourseCouponListStudentDataServer={
            getCourseCouponListStudentDataServer
          }
          pricingSections={true}
        />
      ) : null}
      {overviewReducerData?.overViewDetails?.course?.metaData?.isPurchased ||
      overviewReducerData?.overViewDetails?.course?.installments
        ?.purchasedViaInstallment === 1 ? null : !isStandAlone && multipleCouponsConditions !=
        2 ? (
        <div
          className="viewALLBtnMobile invisibleCouponLine"
          onClick={() => {
            // handleShowModal(true);
            dispatch(showApplyCouponBottomSheetAction(true));
          }}
        >
          {t(
            "components.Tabs.Overview.coupons.haveACouponCode",
            "Have a coupon code? Apply here"
          )}
        </div>
      ) : null}
      {isInternational ? null : (
        <React.Fragment>
          {state?.installments?.isInstallmentActive &&
          !state?.metaData?.isPurchased ? (
            <PayInstallments />
          ) : null}
          {isInternational ||
          state?.metaData?.isPurchased ||
          state?.installments?.installmentAlertState ===
            installmentsAlertStateEnum.COURSE_LOCKED ? null : (
            <StateSelection />
          )}
        </React.Fragment>
      )}
      {state?.paymentSummary ||
      state?.installments?.paidInstallmentSummary?.isPaymentComplete == 0 ||
      state?.metaData?.isPurchased ? (
        <PaidSummary
          installmentData={state?.installments?.paidInstallmentSummary?.info}
          data={state?.paymentSummary}
        />
      ) : null}
      {state?.paymentSummary?.trackingUrl ? (
        <a
          href={state?.paymentSummary?.trackingUrl}
          className={styles.receiptTreack}
          target="_blank"
          rel="noreferrer"
        >
          Track your order
        </a>
      ) : null}
      {state?.installments?.paidInstallmentSummary?.isPaymentComplete == 0 ? (
        <div className={styles.ViewAllInstallmentsWrapper}>
          <div
            onClick={() => openInstallmentUtil()}
            className={styles.ViewAllInstallments}
          >
            <span>
              {t(
                "components.tabs.overview.components.Installments.viewAllInstallments",
                "View All Installments"
              )}
            </span>
            <RightArrowIcon />
          </div>
        </div>
      ) : null}
      {state?.metaData?.isPurchased ? (
        <div className={styles.TC}>
          *{" "}
          {t(
            "components.tabs.overview.components.PricingDetails.T&CTextCondition1",
            "Amount paid was inclusive of taxes. Read"
          )}
          <span> </span>
          <span onClick={() => handleTC()}>
            {t(
              "components.tabs.overview.components.PricingDetails.T&C",
              "Terms & Conditions"
            )}
          </span>{" "}
          {t(
            "components.tabs.overview.components.PricingDetails.T&Chere",
            "here"
          )}
        </div>
      ) : (
        <div className={styles.TC}>
          *{" "}
          {t(
            "components.tabs.overview.components.PricingDetails.T&CTextCondition2",
            "Amount payable is inclusive of taxes."
          )}
          <span> </span>
          <span onClick={() => handleTC()}>
            {" "}
            {t(
              "components.tabs.overview.components.PricingDetails.T&C",
              "Terms & Conditions"
            )}
          </span>{" "}
          {t(
            "components.tabs.overview.components.PricingDetails.T&Capply",
            "apply"
          )}.{" "}
          
        </div>
      )}
    </div>
  );
};

export default React.memo(PricingSection);
